import React, { useState } from "react";
import { Outlet } from "react-router";
import { IUser } from "../types/user";
import { useSearchParams } from "react-router-dom";

const RegistrantFilterContext = React.createContext<any>(null);

const RegistrantFilterProvider = (props: any) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [realtorTypeFilter, setRealtorTypeFilter] = useState<string>("any");
  const [leaseTypeFilter, setLeaseTypeFilter] = useState<string>("any");
  const [statusFilter, setStatusFilter] = useState<string>("any");
  const [ratingFilter, setRatingFilter] = useState<string>("any");
  const [onlineSalesRepFilter, setOnlineSalesRepFilter] = useState<IUser | string>("any");
  const [salesRepFilter, setSalesRepFilter] = useState<IUser | string>("any");
  const [sourceFilter, setSourceFilter] = useState<string>("any");
  const [emailUnsubscribedFilter, setEmailUnsubscribedFilter] = useState<boolean | string>("any");
  const [textUnsubscribedFilter, setTextUnsubscribedFilter] = useState<boolean | string>("any");
  const [connectedFilter, setConnectedFilter] = useState<boolean | string>("any");
  const [startDateFilter, setStartDateFilter] = useState<Date | null>(
    searchParams.get("registrantStart") ? new Date(parseInt(searchParams.get("registrantStart")!, 10)) : null
  );
  const [endDateFilter, setEndDateFilter] = useState<Date | null>(
    searchParams.get("registrantEnd") ? new Date(parseInt(searchParams.get("registrantEnd")!, 10)) : null
  );
  const [cameInStartDateFilter, setCameInStartDateFilter] = useState<Date | null>(
    searchParams.get("cameInStart") ? new Date(parseInt(searchParams.get("cameInStart")!, 10)) : null
  );
  const [cameInEndDateFilter, setCameInEndDateFilter] = useState<Date | null>(
    searchParams.get("cameInEnd") ? new Date(parseInt(searchParams.get("cameInEnd")!, 10)) : null
  );
  const [tags, setTags] = useState<string[]>([]);

  return (
    <RegistrantFilterContext.Provider
      value={{
        realtorTypeFilter,
        setRealtorTypeFilter,
        leaseTypeFilter,
        setLeaseTypeFilter,
        statusFilter,
        setStatusFilter,
        ratingFilter,
        setRatingFilter,
        salesRepFilter,
        setSalesRepFilter,
        onlineSalesRepFilter,
        setOnlineSalesRepFilter,
        sourceFilter,
        setSourceFilter,
        emailUnsubscribedFilter,
        setEmailUnsubscribedFilter,
        textUnsubscribedFilter,
        setTextUnsubscribedFilter,
        connectedFilter,
        setConnectedFilter,
        startDateFilter,
        setStartDateFilter,
        endDateFilter,
        setEndDateFilter,
        cameInStartDateFilter,
        setCameInStartDateFilter,
        cameInEndDateFilter,
        setCameInEndDateFilter,
        tags,
        setTags
      }}
    >
      <Outlet />
    </RegistrantFilterContext.Provider>
  );
};

export { RegistrantFilterContext, RegistrantFilterProvider };
